module.exports = __webpack_public_path__ + "static/Invoice-System-4-bd93e4204bb75d3d02deadbb71a735d9.svg";